require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-id-theft-protection-services.json") })
        }
      }, "path---es-id-theft-protection-services");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-id-theft-protection-services!./.cache/json/es-id-theft-protection-services.json
// module id = 2501
// module chunks = 231608221292675